import axiosInstance from "api/axios";
import { Subcategory } from "types/subcategory.type";

export const subcategoryService = {
  getAll: async (): Promise<Subcategory[]> => {
    const { data } = await axiosInstance.get("/subcategories");
    return data;
  },
  create: async (form: Partial<Subcategory>) => {
    return axiosInstance.post("/subcategories", form);
  },
  update: async (id: number, form: Partial<Subcategory>) => {
    return axiosInstance.put(`/subcategories/${id}`, form);
  },
  delete: async (id: number) => {
    return axiosInstance.delete(`/subcategories/${id}`);
  },
};
